//react
import { useEffect, useState, useRef } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";

//css
import styled from "styled-components";

// component
import Header from "../../component/common/Header";
import NewPwdComplete from "./components/NewPwdComplete";
import Footer from "../../component/common/Footer";
import InnerCon from "../../component/layouts/InnerCon";

export default function NewPwdCompletePage() {
    return (
        <>
            <Wrap>
                <Header />
                <InnerCon>
                    <NewPwdComplete />
                </InnerCon>
                <Footer />
            </Wrap>
        </>
    );
}

const Wrap = styled.div`
    position: relative;
    width: 100%;
`;
